import { ChevronDownGray400Icon } from '@assets/iconComponents';
import { Select as MuiSelect, SelectChangeEvent, SelectProps } from '@mui/material';
import React, { CSSProperties } from 'react';
import { Text } from '..';
import { colorSet } from '@theme';

type ISelectProps = SelectProps & {
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  multiple?: boolean;
  onChange?: (event: SelectChangeEvent<any>, child?: React.ReactNode) => void;
  boxstyle?: CSSProperties;
};

export const Select: React.FC<React.PropsWithChildren<ISelectProps>> = (props) => {
  const { label, placeholder, disabled = false, multiple = false, onChange, boxstyle, children, ...rest } = props;

  return (
    <div style={boxstyle}>
      {label ? (
        <Text variant="subtitle" fontWeight="bold" marginBottom="8px">
          {label}
        </Text>
      ) : null}

      <MuiSelect
        fullWidth
        displayEmpty
        variant="outlined"
        disabled={disabled}
        multiple={multiple}
        onChange={(event, child) => {
          if (onChange) {
            onChange(event, child);
          }
        }}
        IconComponent={(props) => (
          <ChevronDownGray400Icon
            style={{
              width: 20,
              height: 20,
              position: 'absolute',
              right: '16px',
              pointerEvents: 'none'
            }}
          />
        )}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 386,
              '&::-webkit-scrollbar': {
                width: '8px',
                height: '0px'
              },
              '&::-webkit-scrollbar-thumb': {
                borderRadius: '8px',
                backgroundColor: colorSet.primaryMain
              },
              '&::-webkit-scrollbar-track': {
                borderRadius: '8px',
                backgroundColor: colorSet.gray200
              }
            }
          },
          classes: {
            paper: 'scroll'
          }
        }}
        {...rest}
      >
        {children}
      </MuiSelect>
    </div>
  );
};
